import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import LoginDialog from "@/components/quote/LoginDialog";
import Calculator from "@/pages/Calculator";
import RateAdmin from "@/pages/RateAdmin";
import QuoteLookup from "@/pages/QuoteLookup";
import Compare from "@/pages/Compare";
import SalesDashboard from "@/pages/SalesDashboard";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Calculator />} />
            <Route path="/admin" element={<RateAdmin />} />
            <Route path="/lookup" element={<QuoteLookup />} />
            <Route path="/quote/:reference" element={<QuoteLookup />} />
            <Route path="/compare" element={<Compare />} />
            <Route path="/sales" element={<SalesDashboard />} />
          </Routes>
          <LoginDialog />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
